"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const Processing = ({ isProceesing }) => {
    return isProceesing ? ((0, jsx_runtime_1.jsxs)(material_1.Stack, Object.assign({ className: 'wait_stack', justifyContent: 'center', alignItems: 'center', spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(material_1.CircularProgress, { className: 'wait_icon' }), (0, jsx_runtime_1.jsx)(material_1.Typography, Object.assign({ className: 'wait_text' }, { children: " Please wait ..." }))] }))) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}));
};
exports.default = Processing;
